// extracted by mini-css-extract-plugin
module.exports = {"standard":"standard__3L2sg","disabled":"disabled__3oS9g","input":"input__1lHA1","label":"label__1aZDr"};